import { render, staticRenderFns } from "./HomePageBanner.vue?vue&type=template&id=56b38675&scoped=true&"
import script from "./HomePageBanner.vue?vue&type=script&lang=js&"
export * from "./HomePageBanner.vue?vue&type=script&lang=js&"
import style0 from "./HomePageBanner.vue?vue&type=style&index=0&id=56b38675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b38675",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
